// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__sujJW","itemTitle":"ClientEmergencyInfo_itemTitle__3kQ_g","itemText":"ClientEmergencyInfo_itemText__3C9QX"};